import classNames from "components/ui/classNames";
import useTheme from "components/ui/useTheme";
import type { ReactNode } from "react";
import * as React from "react";
import tinycolor from "tinycolor2";

interface IconCardProps {
  primaryColor: string;
  secondaryColor: string;
  icon: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function IconCard({ primaryColor, secondaryColor, icon, children, className }: IconCardProps) {
  const theme = useTheme();
  const isDarkTheme = theme === "dark";
  return (
    <div
      className={classNames(
        "relative flex w-full flex-col rounded-xl border border-slate-200 bg-white p-4 shadow-sm",
        "dark:border-slate-950 dark:bg-slate-800",
        className,
      )}
    >
      <div
        className="mb-4 flex h-7 w-7 items-center justify-center rounded-lg squircle dark:bg-slate-700"
        style={{
          color: isDarkTheme ? tinycolor(primaryColor).brighten(30).toHslString() : primaryColor,
          backgroundColor: isDarkTheme ? tinycolor(secondaryColor).darken(90).toHslString() : secondaryColor,
        }}
      >
        {icon}
      </div>

      <div className="mt-auto">{children}</div>
    </div>
  );
}

interface CardValueProps {
  children: ReactNode;
}

export function CardValue({
  children,
  className,
  ...props
}: CardValueProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>) {
  return (
    <h4 className={classNames("m-0 text-2xl font-bold leading-tight dark:text-slate-200", className)} {...props}>
      {children}
    </h4>
  );
}

interface CardDescriptionProps {
  children: ReactNode;
}

export function CardDescription({ children }: CardDescriptionProps) {
  return (
    <h3 className={classNames("flex text-sm font-medium leading-tight text-gray-500", "dark:text-slate-400")}>
      {children}
    </h3>
  );
}
